// extracted by mini-css-extract-plugin
export default {"main":"GuestInfoRow_main__eYdAO","item":"GuestInfoRow_item__PKBqJ","title":"GuestInfoRow_title__mLaaL","description":"GuestInfoRow_description__QrH6L"};